<template>
    <div>  
        <slide-group-component 
            v-if="item" 
            :object="item"
        />
        
        <main-show 
            class="mt-2"
            v-if="item" 
            :object="item" 
        />
        
        <tower-show 
            v-if="item && item.condominium && item.condominium.towers && item.condominium.towers.length > 0"
            :object="item.condominium.towers" 
        />

        <plan-show 
            v-if="item && item.condominium && item.condominium.plans && item.condominium.plans.length > 0"
            :object="item.condominium.plans" 
        />

        <map-show 
            v-if="item" 
            :object="item" 
        />
    </div>
</template>

<script>
import TowerShow from '@/components/towers/TowerShow.vue';
import MainShow from './MainShow.vue';
import PlanShow from '@/components/plans/PlanShow.vue';
import MapShow from '@/components/maps/MapShow.vue';
import SlideGroupComponent from '@/components/slidegroup/SlideGroupComponent.vue'

export default {
    name: 'PropertyShow',

    components: {
        MainShow,
        TowerShow,
        PlanShow,
        MapShow,
        SlideGroupComponent
    },

    props: {
        object: {
            required: true,
            default: () => ({})
        },
    }, 

    watch: {
        object: {
            handler(newVal) {
                // Atualiza o objeto local se o pai atualizar
                this.item = JSON.parse(JSON.stringify(newVal));
                
            },
            deep: true, // Observa mudanças profundas
            immediate: true // Executa imediatamente ao montar
        }
    },

    data() {
        return {
            item: {}
        };
    },    
};

</script>